export const DATASETS_PATH = '/datasets';
export const DATASETS_TITLE = 'Datasets'
export const WORKDAY_PROJECTS_PATH = '/projects';
export const WORKDAY_PROJECT_DATASETS_PATH  = '/project/:projectId';
export const WORKDAY_PROJECT_DATASET_VIEW_PATH = '/project/:workdayProjectId/datasets';
export const WORKDAY_PROJECTS_TITLE = 'Projects'
